module.exports = __webpack_public_path__ + "static/bg-fe9f4e04b009e13dceb57de2acf5b238.jpg";